export enum EdgeType {
    NORMAL = 'Normal',
    AWAITABLE = 'Awaitable',
    CLIENT_INFO_EDGE = 'ClientInfoEdge',
}
